webpackJsonp([51824475451446],{

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/transportation-2.224eca75.jpg";

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _transportation = __webpack_require__(1158);
	
	var _transportation2 = _interopRequireDefault(_transportation);
	
	__webpack_require__(918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heroStyles = {
	  background: '\n    url(\'' + _transportation2.default + '\')',
	  backgroundSize: 'cover',
	  backgroundPosition: 'center'
	
	};
	
	var TransportationPage = function TransportationPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'transportation-page' },
	      _react2.default.createElement('div', { className: 'transportation-page__hero', style: heroStyles }),
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { className: 'transportation-page__container' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'transportation-page__headline' },
	          'Transportation Details'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'From Airport'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'For information about transportation options from the airport visit their ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://gspairport.com/hire-ground-transportation/', target: '_blank' },
	            'ground transportation page'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Walking'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'There are many restaurants and attractions within easy walking distance of the conference venue.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Driving'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you are driving to Greenville or renting a car, please see ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.visitgreenvillesc.com/travel-info/getting-around/downtown-parking/' },
	            'here'
	          ),
	          ' for downtown parking options.  The hotel also has valet and self-parking available.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Downtown Trolley Service'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Greenville has a FREE downtown trolley service!  The trolley\u2019s hours of operation, route map, and tracker app are available ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.visitgreenvillesc.com/travel-info/getting-around/downtown-trolley/' },
	            'here'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Greenlink Bus System'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In addition to the free downtown trolley, Greenville has an affordable bus transit system with routes around the county.  For routes, schedules, and fares visit their ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'http://greenvillesc.gov/151/Greenlink-Transit' },
	            'website'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Rideshare'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.uber.com/cities/greenville-sc/' },
	            'Uber'
	          ),
	          ' and ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.lyft.com/cities/greenville-sc' },
	            'Lyft'
	          ),
	          ' are available in Greenville.  Visit their websites for information on fare estimates and how to download the apps.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Bicycle Rentals'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Interested in cycling around the city?  Rent a bicycle from ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.visitgreenvillesc.com/listing/greenville-b-cycle/6269/' },
	            'Greenville B-Cycle'
	          ),
	          ' or ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.visitgreenvillesc.com/listing/reedy-rides/6151/' },
	            'Reedy Rides'
	          ),
	          '.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = TransportationPage;
	module.exports = exports['default'];

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-transportation-index-js-dabb5e2aab457e1518a2.js